import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  manualFinalizeMatch,
  manualCancelMatch,
  manualAbandonMatch,
  manualReopenMatch,
  manualUpdateMatch,
  ManualUpdateMatchPayload,
  previewManualFinalizeMatch,
  previewManualReopenMatch,
  previewManualUpdateMatch,
} from "@/api/matches";
import { MatchesQueryKeys } from "@/tanstackQuery/queries/matches";
import { invalidateMatchLists } from "./invalidateMatchLists";

export const useManualFinalizeMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => manualFinalizeMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useManualCancelMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => manualCancelMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useManualAbandonMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => manualAbandonMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useManualReopenMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => manualReopenMatch(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useManualUpdateMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ matchId, payload }: { matchId: string; payload: ManualUpdateMatchPayload }) =>
      manualUpdateMatch(matchId, payload),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

// Previews persist nothing, so they invalidate nothing: the counts are read
// once, shown in the confirmation, and the real mutation above refreshes
// the match after the admin confirms.
export const useManualUpdatePreview = () => {
  return useMutation({
    mutationFn: ({ matchId, payload }: { matchId: string; payload: ManualUpdateMatchPayload }) =>
      previewManualUpdateMatch(matchId, payload),
  });
};

export const useManualFinalizePreview = () => {
  return useMutation({
    mutationFn: (matchId: string) => previewManualFinalizeMatch(matchId),
  });
};

export const useManualReopenPreview = () => {
  return useMutation({
    mutationFn: (matchId: string) => previewManualReopenMatch(matchId),
  });
};
